module.exports = __webpack_public_path__ + "static/media/logo.bf9f732e.svg";